"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlert = exports.Alert = void 0;
var tslib_1 = require("tslib");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var useAlert_1 = require("@reactionable/core/lib/ui/alert/useAlert");
var react_1 = tslib_1.__importDefault(require("react"));
var Alert_1 = tslib_1.__importDefault(require("react-bootstrap/Alert"));
exports.Alert = function (_a) {
    var children = _a.children, icon = _a.icon, props = tslib_1.__rest(_a, ["children", "icon"]);
    return (react_1.default.createElement(Alert_1.default, tslib_1.__assign({}, props),
        icon && react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, tslib_1.__assign({ className: "mr-2" }, icon)),
        children));
};
exports.useAlert = function (props) {
    return useAlert_1.useAlert(tslib_1.__assign({ Component: exports.Alert }, props));
};
//# sourceMappingURL=Alert.js.map